// import React, { useState, useEffect } from "react";

// const VendorQuotations = () => {
//     const [quotations, setQuotations] = useState([]);
//     const [filter, setFilter] = useState("all");
//     const [selectedQuotation, setSelectedQuotation] = useState(null);
//     const [showPopup, setShowPopup] = useState(false);


//     useEffect(() => {

//         const mockQuotations = [
//             {
//                 id: 1,
//                 enquiryId: 63,
//                 vendorId: 101,
//                 vendorName: "Fresh Foods Catering",
//                 status: "accepted",
//                 quotationDate: "20/02/2026",
//                 validUntil: "25/02/2026",
//                 vegPerPlatePrice: 350,
//                 nonVegPerPlatePrice: 450,
//                 mixedPerPlatePrice: 400,
//                 quotationDetails: "Includes all menu items with premium ingredients. Special discount for bulk order.",
//                 addOnPrices: [
//                     {
//                         addOnId: 1,
//                         addOnType: "EXTRA_STARTER",
//                         quantity: 2,
//                         price: 500,
//                         totalAmount: 1000
//                     },
//                     {
//                         addOnId: 2,
//                         addOnType: "DESSERT_COUNTER",
//                         quantity: 1,
//                         price: 800,
//                         totalAmount: 800
//                     }
//                 ]
//             },
//             {
//                 id: 2,
//                 enquiryId: 63,
//                 vendorId: 102,
//                 vendorName: "Spice Garden",
//                 status: "pending",
//                 quotationDate: "21/02/2026",
//                 validUntil: "26/02/2026",
//                 vegPerPlatePrice: 320,
//                 nonVegPerPlatePrice: 420,
//                 mixedPerPlatePrice: 370,
//                 quotationDetails: "Competitive pricing with authentic spices. Includes complimentary welcome drink.",
//                 addOnPrices: [
//                     {
//                         addOnId: 3,
//                         addOnType: "LIVE_COUNTER",
//                         quantity: 1,
//                         price: 1200,
//                         totalAmount: 1200
//                     }
//                 ]
//             },
//             {
//                 id: 3,
//                 enquiryId: 63,
//                 vendorId: 104,
//                 vendorName: "Urban Tadka Caterers",
//                 status: "rejected",
//                 quotationDate: "19/02/2026",
//                 validUntil: "24/02/2026",
//                 vegPerPlatePrice: 380,
//                 nonVegPerPlatePrice: 480,
//                 mixedPerPlatePrice: 430,
//                 quotationDetails: "Premium package with additional items. Includes decorative food displays.",
//                 addOnPrices: [
//                     {
//                         addOnId: 4,
//                         addOnType: "DECORATIVE_SETUP",
//                         quantity: 1,
//                         price: 1500,
//                         totalAmount: 1500
//                     },
//                     {
//                         addOnId: 5,
//                         addOnType: "SPECIAL_DESSERT",
//                         quantity: 3,
//                         price: 200,
//                         totalAmount: 600
//                     }
//                 ]
//             },
//             {
//                 id: 4,
//                 enquiryId: 64,
//                 vendorId: 101,
//                 vendorName: "Fresh Foods Catering",
//                 status: "accepted",
//                 quotationDate: "22/02/2026",
//                 validUntil: "27/02/2026",
//                 vegPerPlatePrice: 340,
//                 nonVegPerPlatePrice: 440,
//                 mixedPerPlatePrice: 390,
//                 quotationDetails: "Wedding special menu with dessert counter. Includes staff service.",
//                 addOnPrices: [
//                     {
//                         addOnId: 6,
//                         addOnType: "STAFF_SERVICE",
//                         quantity: 4,
//                         price: 300,
//                         totalAmount: 1200
//                     },
//                     {
//                         addOnId: 7,
//                         addOnType: "BEVERAGE_COUNTER",
//                         quantity: 1,
//                         price: 1000,
//                         totalAmount: 1000
//                     }
//                 ]
//             },
//             {
//                 id: 5,
//                 enquiryId: 64,
//                 vendorId: 105,
//                 vendorName: "Grand Feast Events",
//                 status: "pending",
//                 quotationDate: "23/02/2026",
//                 validUntil: "28/02/2026",
//                 vegPerPlatePrice: 330,
//                 nonVegPerPlatePrice: 430,
//                 mixedPerPlatePrice: 380,
//                 quotationDetails: "Competitive pricing for wedding event. Includes complimentary cake cutting.",
//                 addOnPrices: []
//             },
//             {
//                 id: 6,
//                 enquiryId: 65,
//                 vendorId: 103,
//                 vendorName: "Royal Dine Services",
//                 status: "pending",
//                 quotationDate: "18/02/2026",
//                 validUntil: "23/02/2026",
//                 vegPerPlatePrice: 300,
//                 nonVegPerPlatePrice: 400,
//                 mixedPerPlatePrice: 350,
//                 quotationDetails: "Basic package with standard items. Economical option for small events.",
//                 addOnPrices: [
//                     {
//                         addOnId: 8,
//                         addOnType: "EXTRA_DESSERT",
//                         quantity: 2,
//                         price: 150,
//                         totalAmount: 300
//                     }
//                 ]
//             }
//         ];

//         setQuotations(mockQuotations);
//     }, []);

//     // Format currency
//     const formatCurrency = (amount) => {
//         return `₹${parseInt(amount).toLocaleString('en-IN')}`;
//     };

//     // Format date
//     const formatDate = (dateString) => {
//         if (!dateString) return "N/A";
//         return dateString;
//     };

//     // Calculate total quotation amount
//     const calculateTotalQuotation = (quotation) => {
//         // Calculate plates total based on actual order counts (this would come from order data)
//         // For demo purposes, assuming 100 plates total
//         const vegPlates = 80;
//         const nonVegPlates = 10;
//         const mixedPlates = 10;

//         const platesTotal = (vegPlates * quotation.vegPerPlatePrice) +
//             (nonVegPlates * quotation.nonVegPerPlatePrice) +
//             (mixedPlates * quotation.mixedPerPlatePrice);

//         const addOnsTotal = quotation.addOnPrices.reduce((sum, addon) => sum + addon.totalAmount, 0);

//         return platesTotal + addOnsTotal;
//     };

//     // Get filtered quotations based on status
//     const getFilteredQuotations = () => {
//         switch (filter) {
//             case "pending":
//                 return quotations.filter(q => q.status === "pending");
//             case "accepted":
//                 return quotations.filter(q => q.status === "accepted");
//             case "rejected":
//                 return quotations.filter(q => q.status === "rejected");
//             default:
//                 return quotations;
//         }
//     };

//     // Get statistics
//     const getStatistics = () => {
//         const total = quotations.length;
//         const pending = quotations.filter(q => q.status === "pending").length;
//         const accepted = quotations.filter(q => q.status === "accepted").length;
//         const rejected = quotations.filter(q => q.status === "rejected").length;

//         return { total, pending, accepted, rejected };
//     };

//     // Handle filter change
//     const handleFilterChange = (e) => {
//         setFilter(e.target.value);
//     };

//     // Get status badge style
//     const getStatusBadge = (status) => {
//         switch (status) {
//             case "accepted":
//                 return {
//                     backgroundColor: "#d4edda",
//                     color: "#155724",
//                     padding: "4px 8px",
//                     borderRadius: "12px",
//                     fontSize: "11px",
//                     fontWeight: "bold",
//                     display: "inline-block"
//                 };
//             case "pending":
//                 return {
//                     backgroundColor: "#fff3cd",
//                     color: "#856404",
//                     padding: "4px 8px",
//                     borderRadius: "12px",
//                     fontSize: "11px",
//                     fontWeight: "bold",
//                     display: "inline-block"
//                 };
//             case "rejected":
//                 return {
//                     backgroundColor: "#f8d7da",
//                     color: "#721c24",
//                     padding: "4px 8px",
//                     borderRadius: "12px",
//                     fontSize: "11px",
//                     fontWeight: "bold",
//                     display: "inline-block"
//                 };
//             default:
//                 return {};
//         }
//     };

//     // Styles
//     const styles = {
//         container: {
//             padding: "20px",
//             backgroundColor: "#f5f5f5",
//             minHeight: "100vh",
//             width: "100%",
//             boxSizing: "border-box"
//         },
//         header: {
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: "20px",
//             flexDirection: window.innerWidth < 768 ? "column" : "row",
//             gap: "15px"
//         },
//         title: {
//             fontSize: window.innerWidth < 768 ? "20px" : "24px",
//             fontWeight: "bold",
//             color: "#333",
//             margin: 0,
//             textAlign: window.innerWidth < 768 ? "center" : "left"
//         },
//         filterContainer: {
//             display: "flex",
//             gap: "10px",
//             flexWrap: "wrap",
//             justifyContent: "center",
//             alignItems: "center"
//         },
//         filterLabel: {
//             fontSize: "14px",
//             fontWeight: "bold",
//             color: "#666"
//         },
//         filterSelect: {
//             padding: "10px 16px",
//             border: "1px solid #ddd",
//             borderRadius: "5px",
//             fontSize: "14px",
//             backgroundColor: "white",
//             cursor: "pointer",
//             minWidth: "180px",
//             outline: "none",
//             transition: "border-color 0.3s ease",
//             ":focus": {
//                 borderColor: "rgb(230 109 51)"
//             }
//         },
//         statsContainer: {
//             display: "flex",
//             gap: window.innerWidth < 768 ? "10px" : "20px",
//             flexWrap: "wrap",
//             marginBottom: "20px",
//             padding: "15px",
//             backgroundColor: "white",
//             borderRadius: "8px",
//             boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
//         },
//         statItem: {
//             display: "flex",
//             alignItems: "center",
//             gap: "5px"
//         },
//         statBadge: {
//             padding: "4px 8px",
//             borderRadius: "12px",
//             fontSize: "11px",
//             fontWeight: "bold",
//             whiteSpace: "nowrap"
//         },
//         tableContainer: {
//             width: "100%",
//             overflowX: "auto",
//             borderRadius: "8px",
//             border: "1px solid #ddd",
//             backgroundColor: "white"
//         },
//         table: {
//             width: "100%",
//             borderCollapse: "collapse",
//             minWidth: "1000px"
//         },
//         tableHeader: {
//             backgroundColor: "rgb(230 109 51)",
//             color: "white",
//             padding: "12px",
//             textAlign: "left",
//             fontSize: window.innerWidth < 768 ? "12px" : "14px",
//             whiteSpace: "nowrap"
//         },
//         tableCell: {
//             padding: window.innerWidth < 768 ? "8px" : "12px",
//             borderBottom: "1px solid #ddd",
//             fontSize: window.innerWidth < 768 ? "12px" : "14px"
//         },
//         quotationCell: {
//             padding: window.innerWidth < 768 ? "8px" : "12px",
//             borderBottom: "1px solid #ddd",
//             fontSize: window.innerWidth < 768 ? "12px" : "14px",
//             fontWeight: "bold",
//             color: "rgb(230 109 51)"
//         },
//         viewButton: {
//             backgroundColor: "rgb(230 109 51)",
//             color: "white",
//             border: "none",
//             padding: "5px 10px",
//             borderRadius: "4px",
//             cursor: "pointer",
//             fontSize: "12px",
//             fontWeight: "bold"
//         },
//         // Popup styles
//         overlay: {
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: "rgba(0, 0, 0, 0.5)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 10001
//         },
//         popup: {
//             backgroundColor: "white",
//             borderRadius: "10px",
//             padding: "25px",
//             maxWidth: "800px",
//             width: "90%",
//             maxHeight: "90vh",
//             overflowY: "auto",
//             boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
//             position: "relative"
//         },
//         popupHeader: {
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: "20px",
//             paddingBottom: "10px",
//             borderBottom: "2px solid rgb(230 109 51)"
//         },
//         popupTitle: {
//             fontSize: "20px",
//             fontWeight: "bold",
//             color: "#333",
//             margin: 0
//         },
//         closeButton: {
//             background: "none",
//             border: "none",
//             fontSize: "24px",
//             cursor: "pointer",
//             color: "#666",
//             padding: "0 10px"
//         },
//         priceGrid: {
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
//             gap: "15px",
//             marginBottom: "20px"
//         },
//         priceCard: {
//             padding: "15px",
//             backgroundColor: "#f8f9fa",
//             borderRadius: "6px",
//             border: "1px solid #dee2e6"
//         },
//         priceLabel: {
//             fontSize: "13px",
//             color: "#666",
//             marginBottom: "5px"
//         },
//         priceValue: {
//             fontSize: "18px",
//             fontWeight: "bold",
//             color: "rgb(230 109 51)"
//         },
//         sectionTitle: {
//             color: "rgb(230 109 51)",
//             marginBottom: "10px",
//             fontSize: "16px",
//             fontWeight: "bold"
//         },
//         detailsText: {
//             padding: "10px",
//             backgroundColor: "#f8f9fa",
//             borderRadius: "6px",
//             marginBottom: "20px"
//         },
//         addOnsTable: {
//             width: "100%",
//             borderCollapse: "collapse",
//             marginTop: "10px"
//         },
//         addOnsHeader: {
//             backgroundColor: "#e9ecef",
//             padding: "10px",
//             textAlign: "left",
//             fontSize: "13px",
//             fontWeight: "bold"
//         },
//         addOnsCell: {
//             padding: "8px",
//             borderBottom: "1px solid #dee2e6",
//             fontSize: "13px"
//         }
//     };

//     const stats = getStatistics();
//     const filteredQuotations = getFilteredQuotations();

//     return (
//         <div style={styles.container}>
//             {/* Header with filters */}
//             <div style={styles.header}>

//                 <div style={styles.filterContainer}>
//                     <label htmlFor="filter-select" style={styles.filterLabel}>
//                         Filter by:
//                     </label>
//                     <select
//                         id="filter-select"
//                         value={filter}
//                         onChange={handleFilterChange}
//                         style={styles.filterSelect}
//                     >
//                         <option value="all">All Quotations ({stats.total})</option>
//                         <option value="pending">Pending ({stats.pending})</option>
//                         <option value="accepted">Accepted ({stats.accepted})</option>
//                         <option value="rejected">Rejected ({stats.rejected})</option>
//                     </select>
//                 </div>
//             </div>

//             {/* Statistics Cards */}
//             <div style={styles.statsContainer}>
//                 <div style={styles.statItem}>
//                     <span style={{ color: "#666", fontSize: window.innerWidth < 768 ? "12px" : "14px" }}>Total Quotations:</span>
//                     <span style={{ fontWeight: "bold", fontSize: window.innerWidth < 768 ? "12px" : "14px" }}>{stats.total}</span>
//                 </div>
//                 <div style={styles.statItem}>
//                     <span style={{ ...styles.statBadge, backgroundColor: "#fff3cd", color: "#856404" }}>
//                         Pending: {stats.pending}
//                     </span>
//                 </div>
//                 <div style={styles.statItem}>
//                     <span style={{ ...styles.statBadge, backgroundColor: "#d4edda", color: "#155724" }}>
//                         Accepted: {stats.accepted}
//                     </span>
//                 </div>
//                 <div style={styles.statItem}>
//                     <span style={{ ...styles.statBadge, backgroundColor: "#f8d7da", color: "#721c24" }}>
//                         Rejected: {stats.rejected}
//                     </span>
//                 </div>
//             </div>

//             {/* Main Table with Enquiry ID, Vendor ID, and Quotation */}
//             <div style={styles.tableContainer}>
//                 <table style={styles.table}>
//                     <thead>
//                         <tr>
//                             <th style={styles.tableHeader}>Enquiry ID</th>
//                             <th style={styles.tableHeader}>Vendor ID</th>
//                             <th style={styles.tableHeader}>Vendor Name</th>
//                             <th style={styles.tableHeader}>Veg/Plate</th>
//                             <th style={styles.tableHeader}>Non-Veg/Plate</th>
//                             {/* <th style={styles.tableHeader}>Mixed/Plate</th> */}
//                             <th style={styles.tableHeader}>Total Quotation</th>
//                             <th style={styles.tableHeader}>Status</th>
//                             <th style={styles.tableHeader}>Quotation Date</th>
//                             <th style={styles.tableHeader}>Valid Until</th>
//                             <th style={styles.tableHeader}>Action</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {filteredQuotations.map((quotation) => (
//                             <tr key={quotation.id}>
//                                 <td style={styles.tableCell}>
//                                     <strong>#{quotation.enquiryId}</strong>
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     <strong>#{quotation.vendorId}</strong>
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     {quotation.vendorName}
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     {formatCurrency(quotation.vegPerPlatePrice)}
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     {formatCurrency(quotation.nonVegPerPlatePrice)}
//                                 </td>
//                                 {/* <td style={styles.tableCell}>
//                                     {formatCurrency(quotation.mixedPerPlatePrice)}
//                                 </td> */}
//                                 <td style={styles.quotationCell}>
//                                     {formatCurrency(calculateTotalQuotation(quotation))}
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     <span style={getStatusBadge(quotation.status)}>
//                                         {quotation.status.charAt(0).toUpperCase() + quotation.status.slice(1)}
//                                     </span>
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     {formatDate(quotation.quotationDate)}
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     {formatDate(quotation.validUntil)}
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     <button
//                                         style={styles.viewButton}
//                                         onClick={() => {
//                                             setSelectedQuotation(quotation);
//                                             setShowPopup(true);
//                                         }}
//                                     >
//                                         View Details
//                                     </button>
//                                 </td>
//                             </tr>
//                         ))}
//                         {filteredQuotations.length === 0 && (
//                             <tr>
//                                 <td colSpan="11" style={{ textAlign: "center", padding: "20px", color: "#666" }}>
//                                     No quotations match the selected filter
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Popup for Quotation Details */}
//             {showPopup && selectedQuotation && (
//                 <div style={styles.overlay} onClick={() => setShowPopup(false)}>
//                     <div style={styles.popup} onClick={(e) => e.stopPropagation()}>
//                         <div style={styles.popupHeader}>
//                             <h3 style={styles.popupTitle}>
//                                 Quotation Details - Enquiry #{selectedQuotation.enquiryId}
//                             </h3>
//                             <button
//                                 style={styles.closeButton}
//                                 onClick={() => setShowPopup(false)}
//                             >
//                                 ×
//                             </button>
//                         </div>

//                         <div style={{ marginBottom: "15px" }}>
//                             <strong>Vendor:</strong> #{selectedQuotation.vendorId} - {selectedQuotation.vendorName}
//                         </div>

//                         {/* Per Plate Prices */}
//                         <div style={styles.priceGrid}>
//                             <div style={styles.priceCard}>
//                                 <div style={styles.priceLabel}>Veg Per Plate</div>
//                                 <div style={styles.priceValue}>{formatCurrency(selectedQuotation.vegPerPlatePrice)}</div>
//                             </div>
//                             <div style={styles.priceCard}>
//                                 <div style={styles.priceLabel}>Non-Veg Per Plate</div>
//                                 <div style={styles.priceValue}>{formatCurrency(selectedQuotation.nonVegPerPlatePrice)}</div>
//                             </div>
//                             {/* <div style={styles.priceCard}>
//                                 <div style={styles.priceLabel}>Mixed Per Plate</div>
//                                 <div style={styles.priceValue}>{formatCurrency(selectedQuotation.mixedPerPlatePrice)}</div>
//                             </div> */}
//                             <div style={styles.priceCard}>
//                                 <div style={styles.priceLabel}>Total Amount</div>
//                                 <div style={styles.priceValue}>{formatCurrency(calculateTotalQuotation(selectedQuotation))}</div>
//                             </div>
//                         </div>

//                         {/* Quotation Details */}
//                         <div style={{ marginBottom: "20px" }}>
//                             <h4 style={styles.sectionTitle}>Quotation Details</h4>
//                             <div style={styles.detailsText}>
//                                 {selectedQuotation.quotationDetails}
//                             </div>
//                         </div>

//                         {/* Add-On Prices */}
//                         {selectedQuotation.addOnPrices.length > 0 && (
//                             <div>
//                                 <h4 style={styles.sectionTitle}>Add-Ons</h4>
//                                 <table style={styles.addOnsTable}>
//                                     <thead>
//                                         <tr>
//                                             <th style={styles.addOnsHeader}>Add-On ID</th>
//                                             <th style={styles.addOnsHeader}>Add-On Type</th>
//                                             <th style={styles.addOnsHeader}>Qty</th>
//                                             <th style={styles.addOnsHeader}>Unit Price</th>
//                                             <th style={styles.addOnsHeader}>Total</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {selectedQuotation.addOnPrices.map((addon, index) => (
//                                             <tr key={index}>
//                                                 <td style={styles.addOnsCell}>#{addon.addOnId}</td>
//                                                 <td style={styles.addOnsCell}>
//                                                     {addon.addOnType.split('_').map(word =>
//                                                         word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
//                                                     ).join(' ')}
//                                                 </td>
//                                                 <td style={styles.addOnsCell}>{addon.quantity}</td>
//                                                 <td style={styles.addOnsCell}>{formatCurrency(addon.price)}</td>
//                                                 <td style={styles.addOnsCell}>{formatCurrency(addon.totalAmount)}</td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         )}

//                         {/* Close button at bottom */}
//                         <div style={{ textAlign: "center", marginTop: "20px" }}>
//                             <button
//                                 style={{
//                                     backgroundColor: "rgb(230 109 51)",
//                                     color: "white",
//                                     border: "none",
//                                     padding: "10px 30px",
//                                     borderRadius: "5px",
//                                     cursor: "pointer",
//                                     fontWeight: "bold"
//                                 }}
//                                 onClick={() => setShowPopup(false)}
//                             >
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default VendorQuotations;

import React, { useState, useEffect } from "react";
import { getCateringOrders, getLeadQuotations } from "../../../Servicefile/ordermanagementservice.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Filter: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
        </svg>
    ),
    Check: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    ),
    X: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    Vendor: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    ),
    Enquiry: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
        </svg>
    ),
    Veg: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
        </svg>
    ),
    NonVeg: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d32f2f" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="8" y1="8" x2="16" y2="16" />
            <line x1="16" y1="8" x2="8" y2="16" />
        </svg>
    ),
    AddOn: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
        </svg>
    ),
    Close: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Total: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 12h-4l-3 9-4-18-3 9H2" />
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    ),
    Eye: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    ),
    Location: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filterGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flexWrap: 'wrap'
    },
    searchInput: {
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        height: '38px',
        minWidth: '220px'
    },
    filterSelect: {
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        height: '38px',
        minWidth: '150px'
    },
    refreshBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '8px 14px',
        background: 'rgb(230 109 51)',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '13px',
        fontWeight: '500',
        cursor: 'pointer',
        height: '38px',
        transition: 'all 0.2s ease'
    },
    statsContainer: {
        display: 'flex',
        gap: '12px',
        flexWrap: 'wrap',
        padding: '16px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    statCard: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 16px',
        background: 'white',
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        flex: '1 1 180px'
    },
    statIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    statIconTotal: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    statIconApproved: {
        background: '#c6f6d5',
        color: '#155724'
    },
    statIconPayment: {
        background: '#bee3f8',
        color: '#004085'
    },
    statContent: {
        display: 'flex',
        flexDirection: 'column'
    },
    statValue: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#2d3748',
        lineHeight: '1.2'
    },
    statLabel: {
        fontSize: '11px',
        fontWeight: '500',
        color: '#718096',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '500px',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '950px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 14px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 14px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        verticalAlign: 'middle'
    },
    badgeApproved: {
        background: '#c6f6d5',
        color: '#155724',
        padding: '3px 10px',
        borderRadius: '12px',
        fontSize: '11px',
        fontWeight: '600'
    },
    badgePayment: {
        background: '#bee3f8',
        color: '#004085',
        padding: '3px 10px',
        borderRadius: '12px',
        fontSize: '11px',
        fontWeight: '600'
    },
    badgeSelected: {
        background: '#d4edda',
        color: '#155724',
        padding: '3px 10px',
        borderRadius: '12px',
        fontSize: '11px',
        fontWeight: '600'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    viewButton: {
        background: 'rgb(230 109 51)',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        padding: '6px 12px',
        fontSize: '12px',
        fontWeight: '600',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        transition: 'all 0.2s ease'
    },
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        padding: '20px'
    },
    modalCard: {
        background: 'white',
        borderRadius: '12px',
        width: '100%',
        maxWidth: '800px',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
        padding: '24px'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #edf2f7',
        paddingBottom: '14px',
        marginBottom: '16px'
    },
    closeButton: {
        background: 'none',
        border: 'none',
        fontSize: '20px',
        cursor: 'pointer',
        color: '#718096'
    },
    quotationCard: {
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '10px',
        padding: '16px',
        marginBottom: '14px'
    }
};

const VendorQuotations = () => {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [filter, setFilter] = useState("all");
    const [searchTerm, setSearchTerm] = useState("");

    // Modal & Quotations State
    const [selectedLead, setSelectedLead] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [quotationsList, setQuotationsList] = useState([]);
    const [loadingQuotations, setLoadingQuotations] = useState(false);
    const [quotationError, setQuotationError] = useState(null);

    const fetchLeads = async () => {
        setLoading(true);
        setError(null);
        try {
            const authToken = localStorage.getItem("authToken");
            if (!authToken) throw new Error("No auth token found");
            const data = await getCateringOrders(authToken);
            
            if (Array.isArray(data)) {
                // Filter: display leads with userId or customerId non-null AND leadStatus is APPROVED or PAYMENT_RECEIVED
                const filteredData = data.filter(item => {
                    const hasUserOrCustomer = (item.userId !== null && item.userId !== undefined) || 
                                             (item.customerId !== null && item.customerId !== undefined);
                    const statusUpper = item.leadStatus ? item.leadStatus.toString().toUpperCase() : "";
                    const isTargetStatus = statusUpper === "APPROVED" || statusUpper === "PAYMENT_RECEIVED";
                    return hasUserOrCustomer && isTargetStatus;
                });
                setLeads(filteredData);
            } else {
                setLeads([]);
            }
        } catch (err) {
            console.error("Error fetching lead quotations:", err);
            setError("Failed to load quotations list.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLeads();
    }, []);

    const handleViewQuotations = async (lead) => {
        setSelectedLead(lead);
        setShowPopup(true);
        setLoadingQuotations(true);
        setQuotationError(null);
        setQuotationsList([]);

        try {
            const authToken = localStorage.getItem("authToken");
            const res = await getLeadQuotations(lead.id, authToken);
            
            // Response format: { success: true, message: "...", data: [...] }
            let quots = [];
            if (res && res.data && Array.isArray(res.data)) {
                quots = res.data;
            } else if (Array.isArray(res)) {
                quots = res;
            }
            setQuotationsList(quots);
        } catch (err) {
            console.error("Error fetching lead quotations for lead #", lead.id, err);
            setQuotationError("Failed to fetch quotations for this lead.");
        } finally {
            setLoadingQuotations(false);
        }
    };

    const formatCurrency = (amount) => amount ? `₹${parseFloat(amount).toLocaleString('en-IN')}` : '₹0';
    const formatDate = (dateString) => dateString || "N/A";

    const filteredLeads = leads.filter(lead => {
        if (filter !== "all") {
            const statusUpper = (lead.leadStatus || '').toUpperCase();
            if (filter === "APPROVED" && statusUpper !== "APPROVED") return false;
            if (filter === "PAYMENT_RECEIVED" && statusUpper !== "PAYMENT_RECEIVED") return false;
        }
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            const leadId = (lead.id || '').toString();
            const userId = (lead.userId || lead.customerId || '').toString();
            const name = (lead.fullName || '').toLowerCase();
            const email = (lead.email || '').toLowerCase();
            const phone = (lead.phoneNumber || '').toLowerCase();
            const event = (lead.event || '').toLowerCase();
            const eventType = (lead.eventType || '').toLowerCase();
            const city = (lead.city || '').toLowerCase();

            return leadId.includes(term) ||
                   userId.includes(term) ||
                   name.includes(term) ||
                   email.includes(term) ||
                   phone.includes(term) ||
                   event.includes(term) ||
                   eventType.includes(term) ||
                   city.includes(term);
        }
        return true;
    });

    const totalLeads = leads.length;
    const approvedLeads = leads.filter(l => (l.leadStatus || '').toUpperCase() === "APPROVED").length;
    const paymentReceivedLeads = leads.filter(l => (l.leadStatus || '').toUpperCase() === "PAYMENT_RECEIVED").length;
    const totalBudget = leads.reduce((sum, l) => sum + (parseFloat(l.budget) || 0), 0);

    return (
        <div style={styles.container}>
            {/* Header & Filters */}
            {/* <div style={styles.header}>
                <div style={styles.title}>
                    📄 Quotations & Approved Leads
                    <span style={styles.titleBadge}>{totalLeads}</span>
                </div>
                <div style={styles.filterGroup}>
                    <input
                        type="text"
                        placeholder="Search Lead ID, User, Email, City..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={styles.searchInput}
                    />
                    <select
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        style={styles.filterSelect}
                    >
                        <option value="all">All Statuses</option>
                        <option value="APPROVED">Approved</option>
                        <option value="PAYMENT_RECEIVED">Payment Received</option>
                    </select>
                    <button onClick={fetchLeads} style={styles.refreshBtn} disabled={loading}>
                        <Icons.Refresh /> {loading ? "Loading..." : "Refresh"}
                    </button>
                </div>
            </div> */}

            {/* Stats Cards */}
            <div style={styles.statsContainer}>
                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconTotal }}>
                        <Icons.Total />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{totalLeads}</span>
                        <span style={styles.statLabel}>Total Leads</span>
                    </div>
                </div>

                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconApproved }}>
                        <Icons.Check />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{approvedLeads}</span>
                        <span style={styles.statLabel}>Approved</span>
                    </div>
                </div>

                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconPayment }}>
                        <Icons.Money />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{paymentReceivedLeads}</span>
                        <span style={styles.statLabel}>Payment Received</span>
                    </div>
                </div>

                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconTotal }}>
                        <Icons.Money />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{formatCurrency(totalBudget)}</span>
                        <span style={styles.statLabel}>Total Budget</span>
                    </div>
                </div>
            </div>

            {/* Error banner */}
            {error && (
                <div style={{ padding: '12px 16px', backgroundColor: '#fff5f5', border: '1px solid #feb2b2', borderRadius: '8px', color: '#c53030', marginBottom: '16px' }}>
                    {error}
                </div>
            )}

            {/* Main Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={styles.th}>Enquiry ID</th>
                            <th style={styles.th}>User / Customer ID</th>
                            <th style={styles.th}>Customer Info</th>
                            <th style={styles.th}>Event & Type</th>
                            <th style={styles.th}>Plates (V / NV)</th>
                            <th style={styles.th}>Budget / Payment</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Lead Status</th>
                            <th style={styles.th}>Event Date</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="9" style={{ textAlign: 'center', padding: '40px', color: '#718096' }}>
                                    Loading leads...
                                </td>
                            </tr>
                        ) : filteredLeads.length > 0 ? (
                            filteredLeads.map((lead, index) => {
                                const statusUpper = (lead.leadStatus || '').toUpperCase();
                                return (
                                    <tr
                                        key={lead.id || index}
                                        style={{
                                            backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                            transition: 'background 0.15s ease'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                    >
                                        <td style={{ ...styles.td, fontWeight: '600', color: 'rgb(230 109 51)' }}>
                                            #{lead.id}
                                        </td>
                                        <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px', fontWeight: '600' }}>
                                            {lead.userId ? `User #${lead.userId}` : lead.customerId ? `Cust #${lead.customerId}` : 'N/A'}
                                        </td>
                                        <td style={styles.td}>
                                            <div style={{ fontWeight: '500' }}>{lead.fullName || 'N/A'}</div>
                                            <div style={{ fontSize: '11px', color: '#718096' }}>{lead.email || ''}</div>
                                            {lead.phoneNumber && <div style={{ fontSize: '11px', color: '#718096' }}>📞 {lead.phoneNumber}</div>}
                                        </td>
                                        <td style={styles.td}>
                                            <div style={{ fontWeight: '600', color: '#2b6cb0' }}>{lead.eventType || lead.event || 'N/A'}</div>
                                            {lead.event && lead.eventType && <div style={{ fontSize: '11px', color: '#718096' }}>{lead.event}</div>}
                                        </td>
                                        <td style={styles.td}>
                                            <div style={{ fontSize: '12px' }}>
                                                <span style={{ color: '#276749', fontWeight: '600' }}>Veg: {lead.vegPlates || 0}</span> | <span style={{ color: '#9b2c2c', fontWeight: '600' }}>NV: {lead.nonVegPlates || 0}</span>
                                            </div>
                                        </td>
                                        <td style={styles.td}>
                                            <div style={{ fontWeight: '700', color: '#2d3748' }}>{formatCurrency(lead.budget)}</div>
                                            {lead.paymentAmount !== null && (
                                                <div style={{ fontSize: '11px', color: '#2b6cb0' }}>Paid: {formatCurrency(lead.paymentAmount)}</div>
                                            )}
                                        </td>
                                        <td style={{ ...styles.td, textAlign: 'center' }}>
                                            <span style={statusUpper === 'PAYMENT_RECEIVED' ? styles.badgePayment : styles.badgeApproved}>
                                                {lead.leadStatus || 'APPROVED'}
                                            </span>
                                        </td>
                                        <td style={styles.td}>
                                            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                <Icons.Calendar /> {formatDate(lead.eventDate)}
                                            </span>
                                            {lead.eventTime && <div style={{ fontSize: '11px', color: '#718096' }}>⏰ {lead.eventTime}</div>}
                                        </td>
                                        <td style={{ ...styles.td, textAlign: 'center' }}>
                                            <button
                                                style={styles.viewButton}
                                                onClick={() => handleViewQuotations(lead)}
                                            >
                                                <Icons.Eye /> View Quotations
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="9" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>No matching leads found</div>
                                        <div style={styles.emptyStateSubtext}>Leads with status APPROVED or PAYMENT_RECEIVED will appear here</div>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Popup Modal for Vendor Quotations of Selected Lead */}
            {showPopup && selectedLead && (
                <div style={styles.overlay} onClick={() => setShowPopup(false)}>
                    <div style={styles.modalCard} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#2d3748' }}>
                                📄 Vendor Quotations - Lead #{selectedLead.id}
                            </h3>
                            <button
                                style={styles.closeButton}
                                onClick={() => setShowPopup(false)}
                            >
                                ✕
                            </button>
                        </div>

                        {/* Lead Summary Box */}
                        <div style={{ background: '#f0f4ff', padding: '12px 16px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #c3dafe' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px', fontSize: '13px' }}>
                                <div><strong>Customer:</strong> {selectedLead.fullName || 'N/A'} ({selectedLead.email || 'N/A'})</div>
                                <div><strong>Event:</strong> {selectedLead.event} - {selectedLead.eventType}</div>
                                <div><strong>Event Date:</strong> {selectedLead.eventDate}</div>
                                <div><strong>City:</strong> {selectedLead.city || 'N/A'}</div>
                                <div><strong>Budget:</strong> <span style={{ color: 'rgb(230 109 51)', fontWeight: '700' }}>{formatCurrency(selectedLead.budget)}</span></div>
                            </div>
                        </div>

                        {/* Quotations List */}
                        <div style={{ marginBottom: '16px' }}>
                            <h4 style={{ fontSize: '15px', fontWeight: '700', color: '#2d3748', marginBottom: '12px', borderBottom: '2px solid rgb(230 109 51)', paddingBottom: '6px' }}>
                                Vendor Submitted Quotations ({quotationsList.length})
                            </h4>

                            {loadingQuotations ? (
                                <div style={{ textAlign: 'center', padding: '30px', color: '#718096' }}>
                                    Loading vendor quotations for Lead #{selectedLead.id}...
                                </div>
                            ) : quotationError ? (
                                <div style={{ padding: '12px', backgroundColor: '#fff5f5', color: '#c53030', borderRadius: '6px' }}>
                                    {quotationError}
                                </div>
                            ) : quotationsList.length > 0 ? (
                                quotationsList.map((q, idx) => (
                                    <div key={q.quotationId || idx} style={styles.quotationCard}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                            <div style={{ fontSize: '15px', fontWeight: '700', color: '#2b6cb0' }}>
                                                🏢 Vendor: {q.vendorName || `Vendor #${q.vendorId}`} (ID: {q.vendorId})
                                            </div>
                                            <div>
                                                <span style={q.status === 'SELECTED' ? styles.badgeSelected : styles.badgeApproved}>
                                                    {q.status || 'SUBMITTED'}
                                                </span>
                                            </div>
                                        </div>

                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '10px', background: 'white', padding: '10px', borderRadius: '6px', marginBottom: '10px', border: '1px solid #edf2f7' }}>
                                            <div>
                                                <div style={{ fontSize: '11px', color: '#718096' }}>Quoted Amount</div>
                                                <div style={{ fontSize: '15px', fontWeight: '700', color: 'rgb(230 109 51)' }}>{formatCurrency(q.quotedAmount)}</div>
                                            </div>
                                            <div>
                                                <div style={{ fontSize: '11px', color: '#718096' }}>Grand Total</div>
                                                <div style={{ fontSize: '15px', fontWeight: '700', color: '#155724' }}>{formatCurrency(q.grandTotal)}</div>
                                            </div>
                                            <div>
                                                <div style={{ fontSize: '11px', color: '#718096' }}>Total Plates</div>
                                                <div style={{ fontSize: '14px', fontWeight: '600' }}>{q.totalPlates || (selectedLead.vegPlates + selectedLead.nonVegPlates)}</div>
                                            </div>
                                            <div>
                                                <div style={{ fontSize: '11px', color: '#718096' }}>Remaining Amount</div>
                                                <div style={{ fontSize: '14px', fontWeight: '600', color: '#c53030' }}>{formatCurrency(q.remainingAmount)}</div>
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '12px', color: '#4a5568', marginBottom: '8px' }}>
                                            <div><strong>Veg/Plate:</strong> {formatCurrency(q.vegPerPlatePrice)}</div>
                                            <div><strong>Non-Veg/Plate:</strong> {formatCurrency(q.nonVegPerPlatePrice)}</div>
                                            <div><strong>Mixed/Plate:</strong> {formatCurrency(q.mixedPerPlatePrice)}</div>
                                            <div><strong>Platform Fee:</strong> {formatCurrency(q.platformFee)}</div>
                                        </div>

                                        {q.vendorFullAddress && (
                                            <div style={{ fontSize: '12px', color: '#718096', marginBottom: '6px' }}>
                                                📍 <strong>Vendor Address:</strong> {q.vendorFullAddress}, {q.vendorCity}, {q.vendorState}
                                            </div>
                                        )}

                                        {q.quotationDetails && (
                                            <div style={{ fontSize: '12px', background: '#fff', padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', color: '#2d3748' }}>
                                                <strong>Notes:</strong> {q.quotationDetails}
                                            </div>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <div style={{ textAlign: 'center', padding: '30px 20px', color: '#718096', background: '#f7fafc', borderRadius: '8px' }}>
                                    <Icons.NoData />
                                    <div style={{ marginTop: '10px', fontSize: '14px', fontWeight: '500' }}>No quotations submitted yet</div>
                                    <div style={{ fontSize: '12px', color: '#a0aec0' }}>Vendors have not submitted quotations for Lead #{selectedLead.id} yet</div>
                                </div>
                            )}
                        </div>

                        <button
                            onClick={() => setShowPopup(false)}
                            style={{
                                width: '100%',
                                padding: '10px',
                                background: 'rgb(230 109 51)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                marginTop: '10px'
                            }}
                        >
                            Close Modal
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default VendorQuotations;